/*
|--------------------------------------------------------------------------
| State
|--------------------------------------------------------------------------
*/

const state = {
    errors: {},
};

/*
|--------------------------------------------------------------------------
| Getters
|--------------------------------------------------------------------------
*/

const getters = {
    getError: state => (form, field) => {
        try {
            const errors = state.errors[form][field];

            if (Array.isArray(errors)) {
                return errors.length > 0 ? window._.first(errors) : undefined;
            }

            if (typeof errors === 'string' && errors !== '') {
                return errors;
            }
        } catch (error) {
            // Fall through.
        }

        return undefined;
    },

    hasError: (state, getters) => (form, field) => {
        return getters.getError(form, field) !== undefined;
    },

    hasErrors: state => Object.keys(state.errors).length > 0,
};

/*
|--------------------------------------------------------------------------
| Actions
|--------------------------------------------------------------------------
*/

const actions = {
    setErrors({ commit }, { form, errors }) {
        commit('setErrors', { form, errors });
    },

    removeError({ commit }, { form, field }) {
        commit('removeError', { form, field });
    },

    clearErrors({ commit }, form) {
        commit('clearErrors', form);
    },
};

/*
|--------------------------------------------------------------------------
| Mutations
|--------------------------------------------------------------------------
*/

const mutations = {
    setErrors(state, { form, errors }) {
        state.errors[form] = errors;
    },

    removeError(state, { form, field }) {
        delete state.errors[form][field];

        if (Object.keys(state.errors[form]).length === 0) {
            delete state.errors[form];
        }
    },

    clearErrors(state, form) {
        if (form === undefined) {
            state.errors = {};
        } else {
            try {
                delete state.errors[form];
            } catch (error) {
                // Fall through.
            }
        }
    }
};

/*
|--------------------------------------------------------------------------
| Export
|--------------------------------------------------------------------------
*/

export const errors = {
    namespaced: true,
    actions,
    getters,
    mutations,
    state,
};
